import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoute = () => {
    const isLoggedin = localStorage.getItem('limitsUser')
    return isLoggedin ? <Outlet /> : <Navigate to="/home" />
}

export default PrivateRoute
